import { Controller } from "@hotwired/stimulus"

// The wizard's sticky action bar. While it is on the page, the page's scroll
// padding matches its height, so a field scrolled to or focused never ends up
// behind the bar.
export default class extends Controller {
  connect() {
    this.reserveSpace()
    this.observer = new ResizeObserver(() => this.reserveSpace())
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer.disconnect()
    document.documentElement.style.removeProperty("scroll-padding-bottom")
  }

  reserveSpace() {
    document.documentElement.style.scrollPaddingBottom = `${this.element.offsetHeight}px`
  }
}
